<template>
  <modal ref="modalEndereco" @voltar="voltarModal" :title="endereco.logradouro || 'Novo Endereço'" :overflow="true">
    <div v-if="modal" v-show="ajustarLocal">
      <map-leaflet ref="map" :dados="empresa" @editarDados="retornoMapa"/>
    </div>

    <div v-if="modal" v-show="!ajustarLocal">
      <div style="height: 100%" v-if="load">
        <loading fullscrean="true"/>
      </div>

      <div v-show="!load">
        <div class="container pt-3" v-if="step === 1">
          <div class="mb-4" v-if="hasGoogleMaps">
            <map-search @selPlace="selPlace" @buscarMapa="buscarMapa"/>
          </div>

          <div class="mb-4" v-else-if="!cepUnico">
            <via-cep-search :usarGeolocalizacao="usarGeolocalizacao" @selPlace="selPlace" @buscarMapa="buscarMapa"/>
          </div>

          <div v-else>
            <h6 class="text-center mt-2 mb-4">Como deseja cadastrar seu endereço?</h6>
            <a href="javascript:" @click="buscarMapa()">
              <card-info title="Buscar pelo Mapa" icon="home" icon-pos="fa-angle-right">
                <div class="small">Encontre o endereço usando o mapa</div>
              </card-info>
            </a>
          </div>

          <div class="mb-4" v-if="isMobile && !gpsError && usarGeolocalizacao">
            <hr>
            <a href="javascript:" @click="buscarGPS()">
              <card-info title="Usar minha localização" icon="gps" icon-pos="fa-angle-right">
                <div class="small">Toque para usar sua localização atual</div>
              </card-info>
            </a>
          </div>
        </div>

        <div v-show="step === 2">
          <form @submit.prevent="validar">
            <div class="container container-endereco">
              <aviso-informativo variante="amarelo" class="small mb-2" v-if="editarLogradouro && limitarCidade">
                Entregas apenas em <b>{{empresa.nome_cidade}} ({{empresa.sigla_estado}})</b>
              </aviso-informativo>
              <div class="row">
                <div class="col-md-12">
                  <div class="mb-2" v-if="!editarLogradouro">
                    <h6 class="font-weight-bold mb-0">{{endereco.logradouro}}</h6>
                    <div>{{endereco.nome_cidade}} - {{endereco.sigla_estado}}</div>
                  </div>
                  <div class="form-group mb-2" v-else>
                    <label for="endereco" class="mb-0">Rua*</label>
                    <input id="endereco" type="text" class="form-control" placeholder="Ex: Rua Joaquim de Oliveira" maxlength="256" v-model="endereco.logradouro" required>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group mb-2">
                    <label for="numero" class="mb-0">Número*</label>
                    <input id="numero" type="tel" class="form-control" placeholder="Ex: 1170" maxlength="11" v-model="endereco.numero" required>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group mb-2">
                    <label for="bairro" class="mb-0">Bairro*</label>
                    <input id="bairro" type="text" class="form-control" placeholder="Ex: Centro" maxlength="45" v-model="endereco.bairro" required>
                  </div>
                </div>
                <div class="col-md-6" v-if="editarLogradouro && !limitarCidade">
                  <label for="bairro" class="mb-0">Cidade*</label>
                  <div class="d-flex mb-2">
                    <input class="form-control mr-1" :value="`${endereco.nome_cidade} - ${endereco.sigla_estado}`" disabled/>
                    <button class="btn btn-primary" type="button" @click="editarCidade()">Alterar</button>
                  </div>
                </div>
              </div>

              <div class="form-group mb-3">
                <label for="complemento" class="mb-0">Referência*<span class="pl-1 text-muted small">({{endereco.complemento ? endereco.complemento.length : 0}} de 100)</span></label>
                <textarea id="complemento" class="form-control" placeholder="Ex: Ponto de Referência (Casa amarela, portão preto..) / Complemento / Bloco / Apto" style="resize: none" v-model="endereco.complemento" maxlength="100" required></textarea>
              </div>

              <div class="mb-3" v-if="endereco.id_endereco">
                <label class="mb-0">
                  <input type="checkbox" class="mr-1"
                         @change="endereco.selecionado = endereco.selecionado === '1' ? '0' : '1'"
                         :checked="endereco.selecionado === '1'">
                  Definir como meu endereço principal
                </label>
              </div>

              <div class="form-group">
                <div class="mb-2">Favoritar Endereço</div>
                <div class="row no-gutters">
                  <div class="col-6 col-sm-4 pr-1">
                    <button type="button" class="btn btn-block" :class="endereco.tipo_endereco === '1' ? 'bg-primary text-white' : 'btn-light border'" @click="toggleTipoEndereco('1')">
                      <icon name="home" size="22" class="mr-2"></icon>
                      Casa
                    </button>
                  </div>
                  <div class="col-6 col-sm-4 pl-1">
                    <button type="button" class="btn btn-block" :class="endereco.tipo_endereco === '2' ? 'bg-primary text-white' : 'btn-light border'" @click="toggleTipoEndereco('2')">
                      <icon name="work" size="22" class="mr-2"></icon>
                      Trabalho
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div class="border-top btn-avancar fixed-container">
              <div class="p-3">
                <button class="btn btn-primary btn-block btn-bottom">
                  <span v-if="load"><i class="fa fa-spinner fa-pulse"></i> Aguarde</span>
                  <span v-else>Salvar</span>
                </button>
              </div>
            </div>
          </form>
        </div>

        <div class="container pt-3" v-show="step === 3">
          <div class="form-group text-center mb-2">
            <label for="nome_cidade" class="mb-3">Procurar cidade</label>
            <div class="d-flex mb-3">
              <div class="form-search w-100 mr-1">
                <span class="input-icon"><i class="fa fa-search"></i></span>
                <input id="nome_cidade" type="search" class="form-control" placeholder="Ex: São Paulo" v-model="searchCid.search" @keyup.enter="buscarCidade()"/>
              </div>
              <div>
                <button class="btn btn-primary" @click="buscarCidade()" :disabled="loadCid">
                  Pesquisar
                </button>
              </div>
            </div>
          </div>
          <div class="mt-4">
            <loading v-if="loadCid"/>
            <div v-if="cidades.length">
              <div class="d-flex align-items-center pointer" v-for="(c, idx) in cidades" :key="idx" @click="selCidade(c)" style="padding: 8px 0">
                <div class="text-left" style="width: 40px">
                  <icon name="address" size="24" class="text-muted"></icon>
                </div>
                <div>
                  <div class="text-muted font-weight-bold">{{ c.nome_cidade }}</div>
                  <div class="small">{{ c.estado }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
import AvisoInformativo from "./AvisoInformativo";
import {TheMask} from 'vue-the-mask';
import MapLeaflet from "./maps/MapLeafleat";
import Loading from "./Loading";
import Modal from "./Modal";
import Icon from "../components/Icon";
import MapSearch from "./maps/MapSearch";
import CardInfo from "./CardInfo";
import ViaCepSearch from "./maps/ViaCepSearch";

export default {
  name: "Endereco",
  components: {AvisoInformativo, ViaCepSearch, CardInfo, MapSearch, Modal, Loading, MapLeaflet, TheMask, Icon},
  props: ['enderecos'],

  data() {
    return {
      token: localStorage.getItem('token'),
      load: false,
      modal: false,
      step: 1,
      ajustarLocal: false,
      editarLogradouro: false,

      endereco: {
        logradouro: '',
        numero: '',
        complemento: '',
        nome_cidade: '',
        sigla_estado: '',
        bairro: '',
        cep: '',
        lat_endereco: '',
        long_endereco: '',
        buscar_mapa: false,
        tipo_endereco: '',
        selecionado: '',
      },

      isMobile: false,
      gpsError: false,

      loadCid: false,
      searchCid: { search: '', uf: '' },
      cidades: []
    }
  },

  methods: {
    openModal(callback) {
      this.modal = true;
      this.$emit('openModal');
      this.$nextTick(() => {
        if (callback) callback()
      });
    },

    closeModal() {
      this.modal = false;
      this.$emit('closeModal');
    },

    voltarModal() {
      if (this.step === 3) {
        this.step = 2;

      } else if (this.ajustarLocal) {
        this.ajustarLocal = false;
        this.$refs.map.remove();

      } else if (!this.endereco.id_endereco && this.step === 2 && this.usarGeolocalizacao) {
        this.step = 1;
        this.$nextTick(() => {
          this.$helpers.focusrElement(this.hasGoogleMaps ? "logradouro" : "cepForm");
        });

      } else {
        this.clearEndereco();
        this.closeModal();

        if (!this.enderecos.length) {
          this.$emit('fechar');
        }
      }
    },

    novoEndereco() {
      this.clearEndereco();

      this.openModal(() => {
        if (!this.usarGeolocalizacao && this.cepUnico) {
          this.step = 2;
          this.editarLogradouro = true;
          this.$nextTick(() => {
            this.$helpers.focusrElement('endereco');
          });

        } else {
          this.$helpers.focusrElement(this.hasGoogleMaps ? "logradouro" : "cepForm");
        }
      });
    },

    editarEndereco(e, selecionar, local) {
      this.step = 2;
      this.ajustarLocal = false;
      this.endereco = {
        id_endereco: e.id_endereco,
        logradouro: e.logradouro,
        numero: e.numero,
        complemento: e.complemento,
        nome_cidade: e.nome_cidade || this.empresa.nome_cidade,
        sigla_estado: e.sigla_estado || this.empresa.sigla_estado,
        bairro: e.bairro,
        cep: e.cep_endereco || '',
        lat_endereco: e.lat_endereco,
        long_endereco: e.long_endereco,
        buscar_mapa: false,
        tipo_endereco: e.tipo_endereco,
        id_cidade: e.id_cidade,
        ibge: e.ibge,
        selecionado: selecionar ? '1' : e.selecionado
      };

      if (selecionar) {
        this.$store.state.load = "Selecionando.."
        this.salvar(true, e);
        return;

      } else if (local) {
        this.step = 1;
        this.$helpers.focusrElement(this.hasGoogleMaps ? "logradouro" : "cepForm");
      }

      this.openModal();
    },

    retornoMapa(local) {
      this.load = true;
      this.ajustarLocal = false;
      this.editarLogradouro = false;
      this.endereco.lat_endereco = local.lat;
      this.endereco.long_endereco = local.lng;

      if (this.endereco.logradouro && this.endereco.numero && !this.endereco.buscar_mapa) {
        this.step = 0;
        this.salvar();

      } else {
        this.buscarGeocoding(true);
      }
    },

    validar() {
      this.load = true;

      if (!this.endereco.numero || this.endereco.numero.trim() === '') {
        this.load = false;
        this.$swal('Por favor informe um número válido!');
        return false;
      }

      if (this.endereco.cep && this.endereco.cep.length < 8 && !this.cepUnico && this.usarGeolocalizacao) {
        this.load = false;
        this.$swal('Por favor remova ou informe um CEP válido').then(() => {
          this.$helpers.focusrElement('cep2');
        });

        return false;
      }

      if (!this.endereco.nome_cidade) {
        this.load = false;
        this.$swal('Por favor, informe um CEP válido para pesquisar sua cidade').then(() => {
          this.$helpers.focusrElement('cep2');
        });

        return false;
      }

      if (this.usarGeolocalizacao && !this.endereco.buscar_mapa) {
        this.buscarGeocoding();

      } else {
        this.salvar();
      }
    },

    salvar(sel, endereco) {
      this.load = true;
      const url = this.$helpers.base_url(this, this.empresa);

      this.$http.post(url + this.token + "/endereco", this.endereco)
        .then(res => {
          this.load = false;
          this.$store.state.load = false;

          if (!res.data || !res.data.success || !res.data.dados) {
            this.$swal(res.data && res.data.msg ? res.data.msg : 'Erro temporário');
            return;
          }

          this.closeModal();
          const dados = res.data.dados;
          this.$store.state.dataUser = dados;
          this.$emit('atualizar', dados, sel ? endereco.id_endereco : null);

          this.$nextTick(() => {
            if (!this.component) {
              if (this.sacola.id_zona) {
                this.sacola.id_zona = null;
                localStorage.setItem('sacola', JSON.stringify(this.sacola));
              }

              if (this.home) {
                this.$router.push(this.url + '/');
              }
            }
          });

        }, res => {
          console.log(res);
          this.$store.state.load = false;
          this.load = false;
          this.$swal(res.data && res.data.msg ? res.data.msg : 'Erro temporário');

          if (sel) {
            this.step = 0;
          }
        });
    },

    buscarGeocoding(gps) {
      let pesquisa = {
        numero: this.endereco.numero,
        logradouro: this.endereco.logradouro,
        nome_cidade: this.endereco.nome_cidade,
        sigla_estado: this.endereco.sigla_estado,
        cep: this.endereco.cep
      };

      if (gps) {
        pesquisa = {
          latitude: this.endereco.lat_endereco,
          longitude: this.endereco.long_endereco
        }
      }

      this.load = true;
      const url = this.$helpers.base_url(this, this.empresa);

      this.$http.post(url + "validar-endereco/" , pesquisa)
        .then(res => {
          this.load = false;
          let dados = res.data;

          if (dados.success) {
            if (gps) {
              if (dados.results && dados.results.length) {
                dados = dados.results;
                const cep = dados.find(e => e.types.includes('postal_code'));
                const logradouro = dados.find(e => e.types.includes('route'));
                const bairro = dados.find(e => e.types.includes('sublocality'));
                const nome_cidade = dados.find(e => e.types.includes('administrative_area_level_2'));
                const sigla_estado = dados.find(e => e.types.includes('administrative_area_level_1'));

                this.endereco.logradouro = logradouro?.long_name !== 'Unnamed Road' ? (logradouro?.long_name || '') : '';
                this.endereco.cep = cep?.long_name ? cep.long_name.replace('-','') : '';
                this.endereco.bairro = bairro ? bairro.long_name : '';
                this.endereco.nome_cidade = nome_cidade?.long_name || this.empresa.nome_cidade;
                this.endereco.sigla_estado = sigla_estado?.short_name || this.empresa.sigla_estado;
                this.step = 2;
                this.$nextTick(() => {
                  this.$helpers.focusrElement('numero');
                });

              } else {
                this.$swal("Não conseguimos processar sua localização. Informe seu endereço manualmente.");
              }

            } else {
              this.endereco.buscar_mapa = false;
              this.endereco.lat_endereco = dados.lat;
              this.endereco.long_endereco = dados.lng;
              this.ajustarLocal = true;
              this.$refs.map.openMapa(this.endereco);
            }

          } else {
            this.$swal("Endereço não encontrado! Informe o local no mapa.").then(() => {
              this.endereco.logradouro = "";
              this.buscarMapa();
            });
          }

        }, res => {
          this.load = false;
          let msg = res.data && res.data.msg ? res.data.msg : 'Erro temporário';
          this.$swal(msg);
        });
    },

    clearEndereco() {
      this.ajustarLocal = false;
      this.editarLogradouro = false;
      this.step = 1;
      this.endereco = {
        logradouro: '',
        numero: '',
        complemento: '',
        bairro: '',
        cep: this.cepUnico ? this.empresa.cep : '',
        id_cidade: this.limitarCidade ? this.empresa.id_cidade : null,
        ibge: this.limitarCidade ? this.empresa.ibge : null,
        nome_cidade: this.empresa.nome_cidade,
        sigla_estado: this.empresa.sigla_estado,
        lat_endereco: '',
        long_endereco: '',
        buscar_mapa: false,
        tipo_endereco: !this.enderecos.length ? '1' : '',
        selecionado: ''
      };

      if (this.$refs.map) {
        this.$refs.map.remove();
      }
    },

    toggleTipoEndereco(tipo) {
      this.endereco.tipo_endereco = tipo !== this.endereco.tipo_endereco ? tipo : '';
    },

    selPlace(p, manual) {
      this.step = 2;
      this.endereco.buscar_mapa = false;
      this.endereco.lat_endereco = '';
      this.endereco.long_endereco = '';

      // sem geolocalizacao e nao sabe o cep entao libera para cadastrar manualmente
      if (manual) {
        this.editarLogradouro = true;
        this.$helpers.focusrElement('endereco');

      } else {
        this.endereco.nome_cidade = p.nome_cidade || this.empresa.nome_cidade;
        this.endereco.logradouro = (p.logradouro || '').trim();
        this.endereco.numero = (p.numero || '').trim();
        this.endereco.bairro = (p.bairro || '').trim();
        this.endereco.sigla_estado = p.sigla_estado || this.empresa.sigla_estado;
        this.endereco.ibge = p.ibge || '';
        this.editarLogradouro = !this.endereco.logradouro;

        // validar cep
        const cep = p.cep || (this.cepUnico ? this.empresa.cep : '');
        this.endereco.cep = cep.length === 8 ? p.cep : '';

        if (!this.limitarCidade) {
          this.endereco.id_cidade = '';
        }

        this.$nextTick(() => {
          this.$helpers.focusrElement(!this.endereco.logradouro ? 'endereco' : 'numero');
        });
      }
    },

    buscarGPS() {
      const msgIos = this.isIOS ? "\n\nAcessando com um Iphone? Verifique se está acessando nosso site diretamente pelo Safari." : "";
      this.gpsError = true;

      if(!navigator.geolocation) {
        this.$swal('Seu dispositivo não suporta geolocalização! ' + msgIos);

      } else {
        this.load = true;

        navigator.geolocation.getCurrentPosition((position) => {
          this.gpsError = false;
          const latitude  = position.coords.latitude;
          const longitude = position.coords.longitude;
          this.endereco.buscar_mapa = false;
          this.endereco.lat_endereco = latitude;
          this.endereco.long_endereco = longitude;
          this.load = false;
          this.ajustarLocal = true;
          this.$refs.map.openMapa(this.endereco);

        }, (positionError) => {
          this.load = false;
          switch(positionError.code) {
            case positionError.PERMISSION_DENIED:
              this.$swal('Não temos permissão para usar sua localização. Limpe as preferências do App ou navegador para usar esta funcionalidade ou faça o cadastro manual do seu endereço! ' + msgIos);
              break;

            default:
              this.$swal('Não foi possível obter sua localização! ' + msgIos);
          }

        }, {
          enableHighAccuracy: true,
          timeout: 40000,
          maximumAge: 0
        });
      }
    },

    buscarMapa() {
      const latitude  = this.empresa.lat_cidade;
      const longitude = this.empresa.long_cidade;

      if (!latitude || !longitude) {
        return;
      }

      this.endereco.lat_endereco = latitude;
      this.endereco.long_endereco = longitude;
      this.endereco.buscar_mapa = true;
      this.load = false;
      this.ajustarLocal = true;
      this.$refs.map.openMapa(this.endereco);
    },

    editarCidade() {
      this.searchCid.search = ''
      this.cidades = [];
      this.step = 3;
      this.$nextTick(() => {
        this.$helpers.focusElement('nome_cidade');
      });
    },

    buscarCidade() {
      if (this.loadCid) return;
      this.loadCid = true;

      this.$http.get('cidades', { params: this.searchCid })
        .then(response => {
          this.cidades = response.data || [];
          this.loadCid = false;

        }, res => {
          console.log(res);
          this.loadCid = false;
        });
    },

    selCidade(cid) {
      this.endereco.id_cidade = cid.id_cidade;
      this.endereco.sigla_estado = cid.sigla_estado;
      this.endereco.nome_cidade = cid.nome_cidade;
      this.endereco.ibge = cid.ibge;
      this.step = 2;
      this.$nextTick(() => {
        this.$helpers.focusElement(!this.endereco.logradouro ? 'endereco' : 'complemento');
      });
    }
  },

  mounted() {
    this.isMobile = this.$helpers.isMobile();
  },

  computed: {
    empresa() {
      return this.$store.state.empresa
    },

    sacola() {
      return this.$store.state.sacola
    },

    limitarCidade() {
      return parseInt(this.empresa.limitar_cidade) === 1;
    },

    hasGoogleMaps() {
      return (this.empresa.integracoes || []).includes('9')
    },

    usarGeolocalizacao() {
      return parseInt(this.empresa.geo_disabled) === 0 || this.hasGoogleMaps;
    },

    cepUnico() {
      return !!this.empresa.cep_cidade;
    }
  }
}
</script>

<style scoped>
.btn-avancar {
  position:fixed;
  right:0;
  bottom:0;
  left:0;
  z-index:1030;
  background-color: #fff;
}

.container-endereco {
  padding-top: 16px;
  padding-bottom: 100px;
  min-height: 100vh;
}

@media (min-width: 768px) {
  .btn-avancar {
    position:static;
    padding-right: 15px;
    padding-left: 15px;
  }

  .container-endereco {
    overflow: auto;
    min-height: auto;
    height: calc(80vh - 142px);
    padding-bottom: 0;
  }
}
</style>
